import { capture as posthogCapture } from './posthog';
import { pushAnalyticsEvent } from './google-tag-manager';

export type DirectoryCardLayout = 'grid' | 'list';

export type DirectoryCardAnalyticsContext = {
  listingId: string;
  listingType: string;
  position: number;
  layout: DirectoryCardLayout;
  device: 'mobile' | 'desktop';
};

function emit(eventName: string, context: DirectoryCardAnalyticsContext) {
  const properties = {
    listing_id: context.listingId,
    type: context.listingType,
    position: context.position,
    layout: context.layout,
    device: context.device,
  };
  pushAnalyticsEvent(eventName, properties);
  posthogCapture(eventName, properties);
}

/** Emits only when a card is actually observed in the viewport. */
export function trackDirectoryCardImpression(context: DirectoryCardAnalyticsContext) {
  emit('directory_card_impression', context);
}

/** Click from a directory result card, including its rendered context. */
export function trackDirectoryCardClick(context: DirectoryCardAnalyticsContext) {
  emit('directory_card_click', context);
}
